module.exports = __webpack_public_path__ + "static/img/rpacj3.1dbf427e.png";